import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { AnamneseService } from 'src/app/admihair/service/anamnese.service';
import { DiagnosticoClienteService } from 'src/app/admihair/service/diagnostico-cliente.service';
import { DiagnosticoCliente } from 'src/app/admihair/api/dto/diagnostico-cliente';
import { MensagemCliente } from 'src/app/admihair/api/dto/mensagem-cliente';
import { MensagemClienteService } from 'src/app/admihair/service/mensagem-cliente.service';
import { Anamnese } from 'src/app/admihair/api/dto/anamnese';
import { FichaDiagnosticoCliente } from 'src/app/admihair/api/dto/ficha-diagnostico-cliente';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { HistoricoCliente } from 'src/app/admihair/api/dto/historico-cliente';
import { ProcessoCliente } from 'src/app/admihair/api/dto/processo-cliente';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { ItemServicoService } from 'src/app/admihair/service/item-servico.service';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { ProcessoClienteService } from 'src/app/admihair/service/processo-cliente.service';
import { ContatoClienteService } from 'src/app/admihair/service/contato-cliente.service';
import { ContatoCliente } from 'src/app/admihair/api/dto/contato-cliente';

@Component({
  selector: 'app-central-cliente-ficha',
  templateUrl: './central-cliente-ficha.component.html',
  styleUrls: ['./central-cliente-ficha.component.scss']
})
export class CentralClienteFichaComponent extends AdmihairBaseComponent implements OnInit {

  id?: number;
  cliente?: Cliente;
  @ViewChild('filter') filter!: ElementRef;
  contatosClientes: ContatoCliente[] = [];
  exibirMensagemSucessoInforme: boolean = false;
  mensagemInforme: Message[] = [];

  loadingAvaliacao: boolean = false;
  exibirDialogAvaliacao: boolean = false;
  valorLgpdAvaliacao: boolean = false;

  loadingAnamnese: boolean = false;
  listaAnamnese: Anamnese[] = [];
  listaFichaDiagnosticoCliente: FichaDiagnosticoCliente[] = [];
  anamneseSelecionada?: Anamnese;
  bloquearCheckLgpd: boolean = false;
  modoEditarAvaliacao: boolean = false;
  diagnosticoCliente: DiagnosticoCliente = {};

  listaRecados: MensagemCliente[] = [];
  listaRecadosInicial: MensagemCliente[] = [];
  exibirDialogRecado: boolean = false;
  loadingRecado: boolean = false;
  tiposMensagemCliente: string[] = ['DO CLIENTE', 'PARA O CLIENTE'];
  tipoMensagemSelecionada?: string;
  modoEditarRecado: boolean = false;
  recadoCliente: MensagemCliente = {};
  bloquearRdStatus: boolean = false;
  bloquearCheckCiencia: boolean = false;
  buscaRecado: string = '';

  loadingAlterarCiencia: boolean = false;

  listaHistoricoCliente: HistoricoCliente[] = [];
  listaHistoricoClienteInicial: HistoricoCliente[] = [];
  buscaHistorico: string = '';

  dataAtual: Date = new Date();

  dataProcesso?: Date = new Date();
  listaProcessos: ProcessoCliente[] = [];
  listaProcessosInicial: ProcessoCliente[] = [];
  exibirDialogProcessos: boolean = false;
  processoClienteSelecionado: ProcessoCliente = {};
  loadingProcessos: boolean = false;
  buscaProcessos: string = '';

  modoEditarProcesso: boolean = false;
  exibirDialogItemProcesso: boolean = false;
  exibirSpinnerDialogItemProcesso: boolean = false;
  listaItensProcesso: ItemProduto[] | ItemServico[] = [];
  itensDialogPaginados?: Paginador<any>;
  tipoItemSelecionado: number = 4;
  loadingTableDialogItens: boolean = false;
  inputBuscaItens?: string = '';
  numeroPaginaDialogItens: number = 0;
  tiposItem: SelectItem[] = [
    { label: 'Serviço', value: 4 },
    { label: 'Produto', value: 3 }
  ];

  itemProcessoSelecionado?: ItemProduto | ItemServico;

  constructor(private clienteService: ClienteService,
    private contatoClienteService: ContatoClienteService,
    private anamneseService: AnamneseService,
    private itemServicoService: ItemServicoService,
    private itemProdutoService: ItemProdutoService,
    private mensagemClienteService: MensagemClienteService,
    private diagnosticoClienteService: DiagnosticoClienteService,
    private processoClienteService: ProcessoClienteService,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.carregarIdUrl();
    this.buscarCliente();
  }

  buscarCliente() {
    this.clienteService.buscarPorId(this.idParametroUrl).subscribe({
      next: (data: Cliente) => {
        this.cliente = data;
        this.listarContatos();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    });
  }

  listarContatos() {
    this.contatoClienteService.listarPorClienteId(this.cliente?.id).subscribe({
      next: (data: ContatoCliente[]) => {
        this.contatosClientes = data;
        this.listarDiagnosticos();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  listarDiagnosticos() {
    this.diagnosticoClienteService.listarFichaDiagnosticoPorCliente(this.cliente?.id).subscribe({
      next: (data: FichaDiagnosticoCliente[]) => {
        this.listaFichaDiagnosticoCliente = data;
        this.listarProcessos();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  listarProcessos() {
    this.processoClienteService.listarPorCliente(this.cliente?.id).subscribe({
      next: (data: ProcessoCliente[]) => {
        this.listaProcessosInicial = data;
        this.listaProcessos = data;
        this.listarRecados();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  listarRecados() {
    this.mensagemClienteService.listarPorClienteId(this.cliente?.id).subscribe({
      next: (data: MensagemCliente[]) => {
        this.listaRecadosInicial = data;
        this.listaRecados = data;
        this.listarHistorico();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  listarHistorico() {
    this.clienteService.listarHistoricoClientePorEmpresa(this.getEmpresa().id, this.cliente?.id).subscribe({
      next: (data: HistoricoCliente[]) => {
        this.listaHistoricoCliente = data;
        this.listaHistoricoClienteInicial = data;
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    });
  }

  abrirDialogAvaliacaoComAnamnese(anamneseSelecionada?: Anamnese) {
    this.modoEditarAvaliacao = false;
    this.anamneseSelecionada = anamneseSelecionada;
    this.diagnosticoCliente = {
      especificacao: '',
      observacao: '',
      anamnese: anamneseSelecionada,
      lgpd: anamneseSelecionada?.lgpd
    };
    this.exibirDialogAvaliacao = true;
    this.listarAnamnese();
  }

  abrirDialogAvaliacao() {
    this.modoEditarAvaliacao = false;
    this.anamneseSelecionada = undefined;
    this.diagnosticoCliente = {
      especificacao: '',
      observacao: '',
      anamnese: undefined,
      lgpd: false
    };
    this.exibirDialogAvaliacao = true;
    this.listarAnamnese();

  }

  listarAnamnese() {
    this.loadingAnamnese = true;
    this.anamneseService.listarPorEmpresa(this.getEmpresa().id).subscribe({
      next: (data: Anamnese[]) => {
        this.listaAnamnese = data;
        this.loadingAnamnese = false;
      },
      error: (err: any) => {
        this.loadingAnamnese = false;
        this.exibirDialogAvaliacao = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  selecionarAnamnese() {
    if (this.anamneseSelecionada?.lgpd != undefined) {
      this.diagnosticoCliente.lgpd = this.anamneseSelecionada.lgpd;
      if (this.anamneseSelecionada.lgpd === true) {
        this.bloquearCheckLgpd = true;
      } else {
        this.bloquearCheckLgpd = false;
      }
    }
  }

  salvarDiagnostico() {
    this.loadingAvaliacao = true;
    this.diagnosticoCliente.cliente = this.cliente;
    this.diagnosticoCliente.anamnese = this.anamneseSelecionada;
    this.diagnosticoCliente.usuario = this.getUsuarioLogadoSistema();
    this.diagnosticoClienteService.salvar(this.diagnosticoCliente).subscribe({
      next: (data: DiagnosticoCliente) => {
        this.loadingAvaliacao = false;
        this.exibirDialogAvaliacao = false;
        this.exibirMensagemSucesso();
        this.listarDiagnosticos();
      },
      error: (err: any) => {
        this.loadingAvaliacao = false;
        this.exibirDialogAvaliacao = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  editarAvaliacao(avaliacao: DiagnosticoCliente) {
    this.modoEditarAvaliacao = true;
    this.exibirDialogAvaliacao = true;
    this.listarAnamnese();
    this.anamneseSelecionada = avaliacao.anamnese;
    this.diagnosticoCliente = { ...avaliacao };
  }

  excluirAvaliacao(id?: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.diagnosticoClienteService.excluir(id).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.listarDiagnosticos();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      }
    });
  }


  verificarTextoLgpd(texto?: string) {
    if (!this.verificarPermissao('PERM_LGPD') && texto) {
      const tamanhoTexto = texto.length;
      let novaString = '';
      let index = 0;
      while (index <= tamanhoTexto) {
        novaString = novaString + '*';
        index++;
      }
      return novaString;
    }

    return texto;
  }

  abrirDialogRecado() {
    this.modoEditarRecado = false;
    this.loadingRecado = false;
    this.recadoCliente = {
      descricao: '',
      observacao: '',
      prioridade: false
    };
    this.tipoMensagemSelecionada = undefined;
    this.exibirDialogRecado = true;
  }

  salvarRecado() {
    this.loadingRecado = true;
    this.recadoCliente.cliente = this.cliente;
    this.recadoCliente.tipo = this.tipoMensagemSelecionada;
    this.recadoCliente.usuario = this.getUsuarioLogadoSistema();

    if (!this.modoEditarRecado) {
      this.mensagemClienteService.salvar(this.recadoCliente).subscribe({
        next: (data: MensagemCliente) => {
          this.loadingRecado = false;
          this.exibirDialogRecado = false;
          this.exibirMensagemSucesso();
          this.listarRecados();
        },
        error: (err: any) => {
          this.loadingRecado = false;
          this.exibirDialogRecado = false;
          this.exibirMensagemErro(err);
        }
      })
    } else {
      this.atualizarRecado();
    }


  }

  atualizarRecado() {
    this.mensagemClienteService.atualizar(this.recadoCliente.id, this.recadoCliente).subscribe({
      next: (data: MensagemCliente) => {
        this.loadingRecado = false;
        this.exibirDialogRecado = false;
        this.exibirMensagemSucesso();
        this.listarRecados();
      },
      error: (err: any) => {
        this.loadingRecado = false;
        this.exibirDialogRecado = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  editarMensagem(mensagem: MensagemCliente) {
    this.modoEditarRecado = true;
    this.recadoCliente = { ...mensagem }
    this.tipoMensagemSelecionada = mensagem.tipo;
    this.exibirDialogRecado = true;
  }

  alterarStatus(idMensagem?: number, novoStatus?: string) {
    this.mensagemClienteService.alterarStatus(idMensagem, novoStatus).subscribe({
      next: () => {
        this.exibirMensagemInforme();
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  alterarCiencia(mensagem?: MensagemCliente) {
    this.mensagemClienteService.alterarCiencia(mensagem?.id, !mensagem?.ciencia).subscribe({
      next: () => {
        this.exibirMensagemInforme();
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  exibirMensagemInforme() {
    this.mensagemInforme = [];
    this.mensagemInforme.push(
      { severity: 'success',
         summary: 'Successo',
          detail: 'Operação realizada com sucesso' 
        });
  }

  excluirMensagem(idMensagem?: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.mensagemClienteService.excluir(idMensagem).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.listarRecados();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      }
    });
  }

  filtrarMensagens(): void {
    if (!this.buscaRecado) {
      this.listaRecados = this.listaRecadosInicial;
      return;
    }

    const buscaMinuscula = this.buscaRecado.toLowerCase();

    this.listaRecados = this.listaRecadosInicial.filter(item => {
      return item.descricao?.toLowerCase().includes(buscaMinuscula) ||
        item.observacao?.toLowerCase().includes(buscaMinuscula) ||
        item.tipo?.toLowerCase().toString().includes(buscaMinuscula);
    }
    );
  }

  limparBuscarMensagem() {
    this.buscaRecado = '';
    this.listaRecados = this.listaRecadosInicial;
  }

  filtrarHistorico(): void {
    if (!this.buscaHistorico) {
      this.listaHistoricoCliente = this.listaHistoricoClienteInicial;
      return;
    }

    const buscaMinuscula = this.buscaHistorico.toLowerCase();

    this.listaHistoricoCliente = this.listaHistoricoClienteInicial.filter(item => {
      return item.nomeProfissional?.toLowerCase().includes(buscaMinuscula) ||
        item.descricaoItem?.toLowerCase().includes(buscaMinuscula) ||
        item.valorUnitario?.toString().includes(buscaMinuscula) ||
        item.quantidade?.toString().includes(buscaMinuscula) ||
        item.valorCobrado?.toString().includes(buscaMinuscula) ||
        item.data?.includes(buscaMinuscula)
    });
  }

  limparBuscaHistorico() {
    this.buscaHistorico = '';
    this.listaHistoricoCliente = this.listaHistoricoClienteInicial;
  }

  abrirDialogProcessos() {
    this.modoEditarProcesso = false;
    this.dataProcesso = new Date();
    this.processoClienteSelecionado = {};
    this.exibirDialogProcessos = true;
  }

  salvarProcesso() {
    this.loadingProcessos = true;
    this.processoClienteSelecionado.data = this.dataProcesso;
    this.processoClienteSelecionado.cliente = this.cliente;
    this.processoClienteSelecionado.usuarioId = this.getUsuarioLogadoSistema().id;

    if (!this.modoEditarProcesso) {
      this.processoClienteService.salvar(this.processoClienteSelecionado).subscribe({
        next: (data: ProcessoCliente) => {
          this.loadingProcessos = false;
          this.exibirDialogProcessos = false;
          this.listarProcessos();
          this.exibirMensagemSucesso();

        },
        error: (err: any) => {
          this.loadingProcessos = false;
          this.exibirDialogProcessos = false;
          this.exibirMensagemErro(err);
        }
      })
    } else {
      this.atualizarProcesso();
    }
  }

  atualizarProcesso() {
    this.processoClienteService.atualizar(this.processoClienteSelecionado.id,
      this.processoClienteSelecionado).subscribe({
        next: (data: ProcessoCliente) => {
          this.loadingProcessos = false;
          this.exibirDialogProcessos = false;
          this.listarProcessos();
          this.exibirMensagemSucesso();

        },
        error: (err: any) => {
          this.loadingProcessos = false;
          this.exibirDialogProcessos = false;
          this.exibirMensagemErro(err);
        }
      })
  }

  excluirProcesso(id?: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.processoClienteService.excluir(id).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.listarProcessos();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      }
    });
  }

  onPageChangeItensDialog(event: any) {
    this.loadingTableDialogItens = true;
    if (this.itensDialogPaginados) {
      this.numeroPaginaDialogItens = event.first / event.rows;
    }
    this.carregarItensProcessoDialog();
  }


  carregarItensProcessoDialog() {
    this.loadingTableDialogItens = true;
    const status = true;
    const idEmpresa = this.getEmpresa().id;
    if (this.tipoItemSelecionado === 4) {
      this.itemServicoService.listarTodosPorEmpresaESituacaoETextoBuscaPaginado(idEmpresa, status,
        this.numeroPaginaDialogItens, this.inputBuscaItens).subscribe({
          next: (data: Paginador<ItemServico>) => {
            this.itensDialogPaginados = data;
            this.listaItensProcesso = data.content
            this.loadingTableDialogItens = false;
          },
          error: (err: any) => {
            this.loadingTableDialogItens = false;
            this.exibirMensagemErro(err);
          }
        });
    } else if (this.tipoItemSelecionado === 3) {
      this.itemProdutoService.listarAtivosPorEmpresa(idEmpresa,
        this.numeroPaginaDialogItens, 5, this.inputBuscaItens).subscribe({
          next: (data: Paginador<ItemServico>) => {
            this.itensDialogPaginados = data;
            this.listaItensProcesso = data.content;
            this.loadingTableDialogItens = false;
          },
          error: (err: any) => {
            this.loadingTableDialogItens = false;
            this.exibirMensagemErro(err);
          }
        });
    }
  }

  abrirDialogItemProcesso() {
    this.exibirDialogItemProcesso = true;
    this.carregarItensProcessoDialog();

  }

  editarProcesso(processo?: ProcessoCliente) {
    this.modoEditarProcesso = true;
    this.processoClienteSelecionado = { ...processo };
    if (processo?.data)
      this.dataProcesso = new Date(processo.data + 'T05:00:00Z');
    this.exibirDialogProcessos = true;
  }

  filtrarProcessos(): void {
    if (!this.buscaProcessos) {
      this.listaProcessos = this.listaProcessosInicial;
      return;
    }
    const buscaMinuscula = this.buscaProcessos.toLowerCase();

    this.listaProcessos = this.listaProcessosInicial.filter(item => {
      return item.descricaoItem?.toLowerCase().includes(buscaMinuscula) ||
        item.descricao?.toLowerCase().includes(buscaMinuscula);
    }
    );
  }

  limparBuscaProcesso() {
    this.buscaProcessos = '';
    this.listaProcessos = this.listaProcessosInicial;
  }

  selecionarItemDialog(item: ItemProduto | ItemServico) {
    this.processoClienteSelecionado.itemId = item.id;
    this.processoClienteSelecionado.descricaoItem = item.descricao;
    this.exibirDialogItemProcesso = false;
  }


  buscarDialogItens(event: Event) {
    this.loadingTableDialogItens = true;
    this.inputBuscaItens = (event.target as HTMLInputElement).value;
    this.carregarItensProcessoDialog();
  }

  limparDialogItens() {
    this.loadingTableDialogItens = true;
    this.filter.nativeElement.value = '';
    this.inputBuscaItens = '';
    this.carregarItensProcessoDialog();
  }


  calcularDataRetorno(data?: Date, numeroDias?: number): Date | null {
    if (data && numeroDias) {
      const novaData = new Date(data);
      novaData.setDate(novaData.getDate() + numeroDias);
      return novaData;
    }
    return null;
  }


}
